import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import Navbar2 from "../components/Navbar2";

function Contact() {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    message: "",
  });

  const phoneNumber = "6281990286066";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, message } = formData;

    if (!name || !message) {
      alert(t("required_alert"));
      return;
    }

    const text = `Halo Wirasana Transport!%0A
${t("form_name")}: ${name}%0A
${t("form_message")}: ${message}`;

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${text}`;
    window.open(whatsappUrl, "_blank");
  };

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <section className="contact-page">
        <Navbar2 />
        <HeroPages name={t("page_title")} />
        <div className="container">
          <div className="contact-div">
            {/* LEFT SIDE INFO */}
            <div className="contact-div__text">
              <h2>{t("lets_get_you")}</h2>
              <p>{t("have_questions_about")}</p>

              <a href="tel:0361286066">
                <i className="fa-solid fa-phone"></i>&nbsp; (0361) - 286-066
              </a>
              <a href="mailto:info@wirasanarentacar.com">
                <i className="fa-solid fa-envelope"></i>&nbsp; info@wirasanarentacar.com
              </a>
              <a href="/">
                <i className="fa-solid fa-location-dot"></i>&nbsp; {t("address_value")}
              </a>
            </div>

            {/* FORM SIDE */}
            <div className="contact-div__form">
              <form onSubmit={handleSubmit}>
                <label>
                  {t("form_name")} <b>*</b>
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder={t("form_placeholder_name")}
                  value={formData.name}
                  onChange={handleChange}
                />

                <label>
                  {t("form_message")} <b>*</b>
                </label>
                <textarea
                  name="message"
                  placeholder={t("form_placeholder_message")}
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>

                <button type="submit">
                  <i className="fa-brands fa-whatsapp"></i>&nbsp; {t("form_button")}
                </button>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Contact;
